import { classNames } from '@/core'
import { useFormField, useStore, Field } from '@/core'
import { TypeaheadPurposely } from '@c/typeahead-purposely'
import { useEffect } from 'preact/hooks'

export const TypeaheadPurposelyField = ({
  label,
  name,
  storeKey,
  className,
  initialValue = false,
  ...props
}) => {
  const store = useStore()
  const { value, setValue, error, setError, formName } = useFormField(name)
  const id = `${formName}-${name}`
  const [form, setForm] = store.use(['forms', formName, 'values', name])
  const [option, setOption] = store.use(
    ['typeahead-drf', storeKey || name, 'option'],
    undefined,
    { cleanup: false }
  )

useEffect(() => {
  const setValuesAsync = async () => {
    if (!initialValue?.id || !initialValue?.name) return
    setForm(initialValue.id)
    setOption({ value: initialValue.id, name: initialValue.name })
  }
  setValuesAsync()
}, [initialValue?.id, initialValue?.name])


  return (
    <Field
      label={label}
      error={error}
      name={name}
      className={classNames(className)}
      {...props}
    >
      <TypeaheadPurposely
        id={id}
        value={value}
        setValue={(val) => {
          error && setError(undefined)
          setValue(val)
        }}
        name={name}
        storeKey={storeKey}
        hasError={!!error}
        {...props}
      />
    </Field>
  )
}
